import React from "react";
import { loginUrls } from "js/api/loginApi";

interface ClasslinkLoginButtonProps {
	deviceId?: string;
}

const ClasslinkLoginButton: React.FC<ClasslinkLoginButtonProps> = ({ deviceId }) => {
	const handleLoginWithClasslink = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		window.location.href = loginUrls.classlink(deviceId);
	};

	return (
		<button className="classlink-login-button" onClick={handleLoginWithClasslink}>
			<div className="classlink-logo" />
			<div className="login-text">Sign in with ClassLink</div>
		</button>
	);
};

export default ClasslinkLoginButton;
